import API from '../Configs';
import queryString from 'query-string';
import React from 'react';
import parseError from './Error';

export const makeRequest = async (token, endpoint, method, body = '', query = '', id = '') => {
  try {
    const params = {
      method,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token,
      },
    };
    
    const queryStr = query === '' ? query : `?${queryString.stringify(query, {arrayFormat: 'bracket'})}`;

    let url = API.ENDPOINTS[endpoint];
    if (id !== '') url = `${url}/${id}`;
    if (body !== '') params.body = JSON.stringify(body);
        const response = await fetch(url + queryStr, params);
        const contentType = response.headers.get("Content-Type").toLowerCase();
        if(response.ok){
            if(contentType.includes("application/vnd.openxmlformats-officedocument")) {
                const blob = await response.blob();
                return { result: true, blob };
            } else {
                const responseJson = await response.json();
                return {result: true, data: responseJson};
            }
        } else {
            const responseJson = await response.json();
            return {result:false, data: parseError(responseJson)}
        }
  }catch (error) {
        return {result:false,data: "Unknown error!"};
  }
};

export const getStatus = (id) => {  
  return API.STATUSES.hasOwnProperty(id) ? API.STATUSES[id] : API.STATUSES[1];
}

export const getRole = (id) => {  
    return API.ROLES.hasOwnProperty(id) ? API.ROLES[id] : API.ROLES[1];
  }
  

export const setDefault = (obj,defaultVal) => {
    return obj === null || obj === undefined || obj === 'undefined' ? defaultVal : obj;
}

export const sanitizeData = (data) => {
    const obj = {};
    const defaultVal = {id : '',name : ''};
    Object.keys(data).map((key) => {
        obj[key] = setDefault(data[key],defaultVal);    
    });
    return obj;
}

export const cutString = (string = "", length = 16) => {
    if( string.length > length ){
        return <span>{ string.substr(0,length) } <span style={{color:"#d1d1d1"}}>...</span></span>;
    }else{
        return string;
    }
}

export const dropdownItems = (options , defaultName = "Select", order = [] ) => {
    const items = [<option key="rand">{ defaultName }</option>];
    options = setDefault(options,{});
    if(order.length > 0){
        order.map(key => {
            const option = options[key];
            items.push(
                <option key={option.id+key} value={option.id}>{option.name}</option>
            );
        });
    }else{
        Object.keys(options).map(index => {
            const option = options[index];
            items.push(
                <option key={option.id+index} value={option.id}>{option.name}</option>
            );
        });
    }
    return items;
}


export const setField = ( endpoint, option, type, successFunction ) => {
    const dataObj = {};
    const { target } = option;
    switch(type){
        case 0:
            dataObj[endpoint] = target.value;
            break;
        case 1:
            dataObj[endpoint] = target.checked ? 1 : 0;
            break;
        case 2:
            dataObj[endpoint] = target.files[0] ? URL.createObjectURL(target.files[0]):false;
            break;
        default:
            null;
    }

    successFunction(dataObj);
}

export const is_url = (str) => {
    const regexp =  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    return regexp.test(str);
}



// WEBPACK FOOTER //
// ./src/Utilities/Common.js